'use strict';

var $ = require('jquery');

var authenticityStatementWrapper = $('.authenticity-statement-wrapper');
var iconClose = authenticityStatementWrapper.find($('.icon-close'));
var $body = $('body');
var $closeIcon = $('.ocd-close.link-1774');

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = '; expires=' + date.toGMTString();
    } else var expires = '';
    document.cookie = escape(name) + '=' + escape(value) + expires + '; path=/';
}

function readCookie(name) {
    var nameEQ = escape(name) + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}

var authenticityStatement = {
    init: function () {
        if (authenticityStatementWrapper.length) {
            if (readCookie('cookieAuthenticityStatement') != 'true') {
                authenticityStatementWrapper.addClass('show-bar');
                $body.addClass('authenticity-bar');
            } else {
                $body.addClass('no-authenticity-bar');
            }

            iconClose.on('click', function (e) {
                createCookie('cookieAuthenticityStatement', 'true', 365);
                authenticityStatementWrapper.removeClass('show-bar');
                $body.addClass('no-authenticity-bar');
            });
            $closeIcon.on('keypress', function (e) {
                if (e.keyCode === 13) {
                    $closeIcon.click();
                    createCookie('cookieAuthenticityStatement', 'true', 365);
                    authenticityStatementWrapper.removeClass('show-bar');
                    $body.addClass('no-authenticity-bar');
                }
            });
        }
    }
};

exports.init = authenticityStatement.init;
